import React from 'react';
import { SearchBox } from '@fluentui/react-components';
import { FluentField } from './Fluent-Field';
import PropTypes from 'prop-types';


export const FluentSearch = ({
    label,
    placeholder,
    size,
    validationMessage,
    componentStyle,
    required,
    onChange,

}) => {
  return (
    <FluentField
        label={label}
        size={size}
        validationMessage={validationMessage}
        required={required}
    >
      <SearchBox
        placeholder={placeholder}
        size={size}
        onChange={onChange}
        className={componentStyle}
      />
    </FluentField>
  )
}

FluentSearch.propTypes = {
    label: PropTypes.string,
    size: PropTypes.string,
    validationMessage: PropTypes.string,
    componentStyle: PropTypes.string,
    required: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
};